const videoWrappers = document.querySelectorAll(".video-container");

if (videoWrappers.length > 0) {
  videoWrappers.forEach(videoWrapper => {
    const videoEl = videoWrapper.querySelector("video");
    const playButton = videoWrapper.querySelector(".play");
    const pauseButton = videoWrapper.querySelector(".pause");

    playButton.addEventListener('click', e => playVideo(videoEl, videoWrapper, pauseButton)); 
    pauseButton.addEventListener('click', e => pauseVideo(videoEl, videoWrapper, playButton)); 
  });
}

function playVideo(video, wrapper, pauseButton) {
  video.play();
  wrapper.setAttribute('data-play-state', 'playing');
  pauseButton.focus();
}

function pauseVideo(video, wrapper, playButton) {
  video.pause();
  wrapper.setAttribute('data-play-state', 'paused');
  playButton.focus();
}

